import React from 'react';
import classnames from 'classnames';

import { FlexRow } from 'ui-components/components/flex';

import style from './style.module.less';

/**
 * Returns tab expanded section container component
 * Contains the expanded content for a returns tab section when it's active
 * @typedef {object} ReturnsTabExpandedSectionProps
 * @property {React.ReactNode} children - The content to be displayed inside the expanded section
 * @param {ReturnsTabExpandedSectionProps} props - Component props
 * @returns {React.ReactElement} The Returns tab expanded section container
 */
export const ReturnsTabExpandedSection = ({ children, className }) => (
  <FlexRow className={classnames(style.returnsTabExpandedSection, className)}>{children}</FlexRow>
);
